// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".translations[data-v-27e34aa2]{max-height:400px;overflow-y:auto}.translations-list tbody tr:first-child td[data-v-27e34aa2]{border-top:none}.clear-translation-keyword[data-v-27e34aa2]{position:absolute;top:-6px;right:51px;z-index:9}", ""]);
// Exports
module.exports = exports;
